export const TICK_COUNT = 6;

export const tickStep = (min: number, max: number, count: number): number => {
  const step = Math.abs(max - min) / Math.max(1, count);

  if (!(step > 0)) return 1;

  const power = Math.pow(10, Math.floor(Math.log10(step)));
  const eased = step / power;

  let stepped = eased >= 7.5 ? 10 : eased >= 3 ? 5 : eased >= 1.5 ? 2 : 1;
  const spacing = stepped * power;
  const intervals = Math.floor(Math.max(min, max) / spacing) - Math.ceil(Math.min(min, max) / spacing);
  // Keep the readable step unless its actual ticks exceed the interval budget.
  if (intervals > Math.max(1, count)) stepped = stepped === 1 ? 2 : stepped === 2 ? 5 : 10;

  return stepped * power;
};

export const SECOND = 1000;

export const MINUTE = SECOND * 60;

export const HOUR = MINUTE * 60;

export const DAY = HOUR * 24;

export const TIME_STEPS = [
  SECOND,
  SECOND * 5,
  SECOND * 15,
  SECOND * 30,
  MINUTE,
  MINUTE * 5,
  MINUTE * 15,
  MINUTE * 30,
  HOUR,
  HOUR * 3,
  HOUR * 6,
  HOUR * 12,
  DAY,
  DAY * 2,
  DAY * 7,
];

export const timeStep = (min: number, max: number, count: number): number => {
  const want = Math.abs(max - min) / Math.max(1, count);

  if (!(want > 0)) return SECOND;

  for (const step of TIME_STEPS) {
    if (step >= want) return step;
  }

  return tickStep(min, max, count);
};

